import { createContext } from 'react';
import { ResourceType, VersionedPeriod } from 'src/models';
import { FormConfig, FormElementScript, FormType } from 'src/models/form.model';

import { AnyValue, ID, RecordObject, VoidFn } from 'src/models/general.model';

interface FormParserType {
  value: AnyValue;
  fieldName: string;
  script: Partial<FormElementScript>;
  onChange: (value: AnyValue) => void;
  onSubmit?: () => void;
  config?: Partial<FormConfig>;
  action?: VoidFn; // Parser can call action function (e.g click on button)
  readData?: AnyValue; // data that is passed to the Parser (read/write data can be from different fields)
  additionalReadData?: RecordObject<AnyValue>;
  writeData?: Array<(value: AnyValue) => void>; // data that can be set by Parser (read/write data can be from different fields)
  isDisabled?: boolean;
  isReadonly?: boolean;
  resource_id?: ID; // required for autocomplete
  resource_type?: ResourceType; // required for autocomplete
  actions?: RecordObject<VoidFn>;
  error?: string; // field error
  initialState?: FormType;
  period?: VersionedPeriod;
}

export const FormParserContext = createContext({} as FormParserType);
